'use strict';

const config = {
    dataNodeId: 'node-id',
    productLinksUpdatedEventName: 'productLinks.updated',
    productLinksUpdatedEventTarget: 'body',
    target: '.c-product-links-counter'
};

/**
 * ProductLinksCounter
 *
 * Component for displaying the number of product links associated with a node and responding to product link changes.
 */
class ProductLinksCounter {

    /**
     * Constructor.
     *
     * @param {jQuery} $elt The element for the component.
     */
    constructor($elt) {
        this.$elt = $elt;
        this.nodeId = parseInt($elt.data(config.dataNodeId), 10);

        $(config.productLinksUpdatedEventTarget).on(
            config.productLinksUpdatedEventName,
            (e, data) => this.handleProductLinksUpdated(e, data)
        );
    }

    /**
     * Handles the product links being updated.
     *
     * @param {Event} e The event.
     * @param {Object} data Some data associated with the event.
     */
    handleProductLinksUpdated(e, data) {
        // Only update the count if the node in the event is the node that this component cares about.
        if (parseInt(data.nodeId, 10) === this.nodeId) {
            this.$elt.text(data.productLinks.length);
        }
    }
}

$(window).load(function() {
    $(config.target).each(function () {
        new ProductLinksCounter($(this));
    });
});



// WEBPACK FOOTER //
// ./src/js/components/product-links-counter.js